import { defineMessages } from 'react-intl';

export default defineMessages({
  useAvailableCreditMenuItemUseAvailableCredit: {
    defaultMessage: 'Use available credit',
    description: '',
    id: 'useAvailableCreditMenuItem.useAvailableCredit',
  },
});
